import { Grid } from "@mui/material";
import ChangePassword from "components/local/dashboard/changePassword";
import SideBar from "components/UI/SideBar/SideBar";
import React from "react";

const ChangePasswordPage = () => {
  return (
    <Grid container sx={{ backgroundColor: "#F5F5F5" }}>
      <Grid item md={2}>
        <SideBar />
      </Grid>
      <Grid
        item
        md={10}
        sm={6}
        xs={12}
        sx={{ marginInline: { sm: "auto", md: "initial" } }}
      >
        <ChangePassword />
      </Grid>
    </Grid>
  );
};

export default ChangePasswordPage;
